var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmploymentOpportunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 167,
    viewBox: "0 0 195 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2761_30850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2019 139.517H16.9465C15.7641 139.517 14.8052 138.558 14.8052 137.376V29.809C14.8052 29.2012 15.2984 28.708 15.9061 28.708H74.9299C75.5376 28.708 76.0308 29.2012 76.0308 29.809V126.825H76.0606V137.376C76.0606 138.558 77.0195 139.517 78.2019 139.517Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9453 139.186C15.9467 139.186 15.1343 138.374 15.1343 137.375V29.8087C15.1343 29.3838 15.48 29.0381 15.9049 29.0381H74.9287C75.3537 29.0381 75.6994 29.3838 75.6994 29.8087V127.155H75.7291V137.375C75.7291 138.09 76.034 138.735 76.5205 139.186H16.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3422 125.165V137.375C80.3422 138.557 79.3833 139.516 78.2009 139.516C77.0185 139.516 76.0596 138.557 76.0596 137.375V125.165H80.3422Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4174 63.9061C42.2539 63.9061 39.1705 62.7971 36.7351 60.7834C33.5902 58.1817 31.7866 54.3518 31.7866 50.2753C31.7866 42.7593 37.9014 36.6445 45.4174 36.6445C52.9334 36.6445 59.0482 42.7593 59.0482 50.2753C59.0482 54.3524 57.2441 58.1825 54.0987 60.7834C51.666 62.797 48.5828 63.9061 45.4174 63.9061Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9474 50.275C57.9474 54.1624 56.176 57.637 53.3972 59.9346C51.2305 61.7281 48.4484 62.8048 45.4175 62.8048C42.3855 62.8048 39.6046 61.727 37.4368 59.9346C34.658 57.6359 32.8877 54.1624 32.8877 50.275C32.8877 43.3555 38.4981 37.7451 45.4175 37.7451C52.337 37.7451 57.9474 43.3555 57.9474 50.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9469 50.2729C57.9469 54.1614 56.1755 57.6349 53.3967 59.9326C51.23 61.726 48.4479 62.8027 45.417 62.8027C42.385 62.8027 39.6041 61.7249 37.4363 59.9326C34.6575 57.6349 32.8872 54.1603 32.8872 50.2729C32.8872 43.3534 38.4976 37.7441 45.417 37.7441C52.3365 37.7441 57.9469 43.3534 57.9469 50.2729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3974 54.2652V59.9329C51.2307 61.7263 48.4486 62.8031 45.4177 62.8031C42.3858 62.8031 39.6048 61.7252 37.437 59.9329V54.2652L43.1256 51.7694L45.1117 50.8975L47.7099 51.9533L53.3974 54.2652Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.335 45.9068V44.4089L42.5 44.3545V45.9068C42.2314 45.9068 42.0137 46.1245 42.0137 46.3931V48.1992C42.0137 48.4677 42.2313 48.6855 42.5 48.6855V49.1718C42.5 49.8522 42.7348 50.4765 43.1252 50.9727V53.0386C43.1252 54.3046 44.1515 55.3309 45.4175 55.3309C46.6834 55.3309 47.7097 54.3046 47.7097 53.0386V50.9727C48.1001 50.4765 48.335 49.8522 48.335 49.1718V48.6855C48.6035 48.6855 48.8212 48.4678 48.8212 48.1992V46.3931C48.8212 46.1246 48.6035 45.9068 48.335 45.9068Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5808 42.3755C45.7513 42.121 45.0197 42.0926 44.2545 42.3755C43.0002 42.8395 42.0427 43.8326 42.3309 45.1386L42.6686 47.5405C42.6686 47.5405 44.7827 44.9424 47.3688 44.9996L48.2515 47.5405L48.5045 45.1386C48.7926 43.8326 47.8594 42.7679 46.5808 42.3755Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8972 71.6501H21.9379C21.284 71.6501 20.7539 71.12 20.7539 70.4662C20.7539 69.8123 21.284 69.2822 21.9379 69.2822H68.8972C69.551 69.2822 70.0811 69.8123 70.0811 70.4662C70.0811 71.12 69.551 71.6501 68.8972 71.6501Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8972 78.0642H21.9379C21.284 78.0642 20.7539 77.5341 20.7539 76.8802C20.7539 76.2264 21.284 75.6963 21.9379 75.6963H68.8972C69.551 75.6963 70.0811 76.2264 70.0811 76.8802C70.0811 77.5342 69.551 78.0642 68.8972 78.0642Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8977 84.4783H21.9383C21.2845 84.4783 20.7544 83.9482 20.7544 83.2943C20.7544 82.6405 21.2845 82.1104 21.9383 82.1104H68.8977C69.5515 82.1104 70.0816 82.6405 70.0816 83.2943C70.0816 83.9482 69.5515 84.4783 68.8977 84.4783Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8977 90.8952H21.9383C21.2845 90.8952 20.7544 90.3651 20.7544 89.7113C20.7544 89.0574 21.2845 88.5273 21.9383 88.5273H68.8977C69.5515 88.5273 70.0816 89.0574 70.0816 89.7113C70.0816 90.3652 69.5515 90.8952 68.8977 90.8952Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8972 97.3083H21.9379C21.284 97.3083 20.7539 96.7782 20.7539 96.1244C20.7539 95.4705 21.284 94.9404 21.9379 94.9404H68.8972C69.551 94.9404 70.0811 95.4705 70.0811 96.1244C70.0811 96.7783 69.551 97.3083 68.8972 97.3083Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8972 103.723H21.9379C21.284 103.723 20.7539 103.193 20.7539 102.539C20.7539 101.886 21.284 101.355 21.9379 101.355H68.8972C69.551 101.355 70.0811 101.886 70.0811 102.539C70.0811 103.193 69.551 103.723 68.8972 103.723Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8972 110.138H21.9379C21.284 110.138 20.7539 109.608 20.7539 108.954C20.7539 108.301 21.284 107.771 21.9379 107.771H68.8972C69.551 107.771 70.0811 108.301 70.0811 108.954C70.0811 109.608 69.551 110.138 68.8972 110.138Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8977 116.552H21.9383C21.2845 116.552 20.7544 116.022 20.7544 115.369C20.7544 114.715 21.2845 114.185 21.9383 114.185H68.8977C69.5515 114.185 70.0816 114.715 70.0816 115.369C70.0816 116.022 69.5515 116.552 68.8977 116.552Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8977 122.968H21.9383C21.2845 122.968 20.7544 122.437 20.7544 121.784C20.7544 121.13 21.2845 120.6 21.9383 120.6H68.8977C69.5515 120.6 70.0816 121.13 70.0816 121.784C70.0816 122.437 69.5515 122.968 68.8977 122.968Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8972 129.383H21.9379C21.284 129.383 20.7539 128.852 20.7539 128.199C20.7539 127.545 21.284 127.015 21.9379 127.015H68.8972C69.551 127.015 70.0811 127.545 70.0811 128.199C70.0811 128.853 69.551 129.383 68.8972 129.383Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.528 29.809V137.376C179.528 138.558 178.569 139.517 177.387 139.517H116.131C117.314 139.517 118.273 138.558 118.273 137.376V126.825H118.302V29.809C118.302 29.2012 118.796 28.708 119.403 28.708H178.427C179.035 28.708 179.528 29.2012 179.528 29.809Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.386 139.186C178.385 139.186 179.197 138.374 179.197 137.375V29.8087C179.197 29.3838 178.852 29.0381 178.427 29.0381H119.403C118.978 29.0381 118.632 29.3838 118.632 29.8087V127.155H118.602V137.375C118.602 138.09 118.298 138.735 117.811 139.186H177.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.272 125.165V137.375C118.272 138.557 117.313 139.516 116.131 139.516C114.949 139.516 113.99 138.557 113.99 137.375V125.165H118.272Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.915 63.9061C152.079 63.9061 155.162 62.7971 157.598 60.7834C160.743 58.1817 162.546 54.3518 162.546 50.2753C162.546 42.7593 156.431 36.6445 148.915 36.6445C141.399 36.6445 135.285 42.7593 135.285 50.2753C135.285 54.3524 137.089 58.1825 140.234 60.7834C142.667 62.797 145.75 63.9061 148.915 63.9061Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.386 50.275C136.386 54.1624 138.157 57.637 140.936 59.9346C143.103 61.7281 145.885 62.8048 148.916 62.8048C151.948 62.8048 154.729 61.727 156.896 59.9346C159.675 57.6359 161.445 54.1624 161.445 50.275C161.445 43.3555 155.835 37.7451 148.916 37.7451C141.996 37.7451 136.386 43.3555 136.386 50.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.446 50.274C161.446 54.1614 159.674 57.636 156.896 59.9326C154.729 61.726 151.947 62.8027 148.916 62.8027C145.884 62.8027 143.103 61.7249 140.935 59.9326C138.157 57.6349 136.386 54.1614 136.386 50.274C136.386 43.3534 141.997 37.7441 148.916 37.7441C155.836 37.7441 161.446 43.3536 161.446 50.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.895 54.2652V59.9329C154.728 61.7263 151.946 62.8031 148.915 62.8031C145.883 62.8031 143.102 61.7252 140.935 59.9329V54.2652L146.623 51.7694L147.003 51.6021L148.609 50.8975L150.624 51.7166L151.207 51.9533L156.895 54.2652Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.916 52.1404C151.187 52.1404 153.028 50.0363 153.028 47.4408C153.028 44.8453 151.187 42.7412 148.916 42.7412C146.644 42.7412 144.803 44.8453 144.803 47.4408C144.803 50.0363 146.644 52.1404 148.916 52.1404Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.833 45.9079V45.0049H145.998V45.9079C145.729 45.9079 145.512 46.1255 145.512 46.3942V48.2003C145.512 48.4688 145.729 48.6865 145.998 48.6865V49.1728C145.998 49.8532 146.233 50.4776 146.623 50.9738V53.0397C146.623 54.3057 147.65 55.332 148.916 55.332C150.181 55.332 151.208 54.3057 151.208 53.0397V50.9738C151.598 50.4776 151.833 49.8532 151.833 49.1728V48.6865C152.102 48.6865 152.319 48.4689 152.319 48.2003V46.3941C152.319 46.1255 152.102 45.9079 151.833 45.9079Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.916 42.9336C148.327 42.9336 147.78 43.1009 147.322 43.3428C147.318 43.3447 147.314 43.3462 147.311 43.3481C147.304 43.3518 147.297 43.3557 147.29 43.3594C147.287 43.3609 147.284 43.3624 147.281 43.3638C146.552 43.7492 145.942 44.227 145.869 45.3288C145.866 45.3732 145.867 45.4174 145.865 45.4618C145.743 45.5382 145.638 45.6589 145.558 45.7798C145.049 46.554 144.952 47.5832 145.307 48.4391C145.374 48.6007 145.457 48.7575 145.498 48.9276C145.539 49.0977 145.534 49.2888 145.436 49.4336C145.933 49.1769 146.285 48.6683 146.373 48.1184C146.478 48.4199 146.566 48.7265 146.558 49.0432C146.546 49.4815 146.348 49.8983 146.078 50.2436C145.807 50.589 145.468 50.8725 145.131 51.1531C146.141 50.7969 146.979 49.9804 147.361 48.9795C147.592 48.3718 147.66 47.7161 147.735 47.0698C147.782 46.6581 147.835 46.2426 147.935 45.8414C148.242 45.8829 148.572 45.9057 148.916 45.9057C149.827 45.9057 150.64 45.7469 151.175 45.4985C151.446 45.8095 151.833 45.9064 151.833 45.9064L152.171 44.8992C152.171 44.8891 150.527 42.9336 148.916 42.9336Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.436 71.6501H172.395C173.049 71.6501 173.579 71.12 173.579 70.4662C173.579 69.8123 173.049 69.2822 172.395 69.2822H125.436C124.782 69.2822 124.252 69.8123 124.252 70.4662C124.252 71.12 124.782 71.6501 125.436 71.6501Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.436 78.0642H172.396C173.05 78.0642 173.58 77.5341 173.58 76.8802C173.58 76.2264 173.05 75.6963 172.396 75.6963H125.436C124.783 75.6963 124.252 76.2264 124.252 76.8802C124.252 77.5342 124.783 78.0642 125.436 78.0642Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.436 84.4783H172.396C173.05 84.4783 173.58 83.9482 173.58 83.2943C173.58 82.6405 173.05 82.1104 172.396 82.1104H125.436C124.783 82.1104 124.252 82.6405 124.252 83.2943C124.252 83.9482 124.783 84.4783 125.436 84.4783Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.436 90.8952H172.396C173.05 90.8952 173.58 90.3651 173.58 89.7113C173.58 89.0574 173.05 88.5273 172.396 88.5273H125.436C124.783 88.5273 124.252 89.0574 124.252 89.7113C124.252 90.3652 124.783 90.8952 125.436 90.8952Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.436 97.3083H172.395C173.049 97.3083 173.579 96.7782 173.579 96.1244C173.579 95.4705 173.049 94.9404 172.395 94.9404H125.436C124.782 94.9404 124.252 95.4705 124.252 96.1244C124.252 96.7783 124.782 97.3083 125.436 97.3083Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.436 103.723H172.395C173.049 103.723 173.579 103.193 173.579 102.539C173.579 101.886 173.049 101.355 172.395 101.355H125.436C124.782 101.355 124.252 101.886 124.252 102.539C124.252 103.193 124.782 103.723 125.436 103.723Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.436 110.138H172.395C173.049 110.138 173.579 109.608 173.579 108.954C173.579 108.301 173.049 107.771 172.395 107.771H125.436C124.782 107.771 124.252 108.301 124.252 108.954C124.252 109.608 124.782 110.138 125.436 110.138Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.436 116.552H172.395C173.049 116.552 173.579 116.022 173.579 115.369C173.579 114.715 173.049 114.185 172.395 114.185H125.436C124.782 114.185 124.252 114.715 124.252 115.369C124.252 116.022 124.782 116.552 125.436 116.552Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.436 122.968H172.396C173.05 122.968 173.58 122.437 173.58 121.784C173.58 121.13 173.05 120.6 172.396 120.6H125.436C124.783 120.6 124.252 121.13 124.252 121.784C124.252 122.437 124.783 122.968 125.436 122.968Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.436 129.383H172.396C173.05 129.383 173.58 128.852 173.58 128.199C173.58 127.545 173.05 127.015 172.396 127.015H125.436C124.783 127.015 124.252 127.545 124.252 128.199C124.252 128.853 124.783 129.383 125.436 129.383Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 29.8109V126.819H67.6482C67.5657 126.819 67.482 126.815 67.3906 126.807L67.3664 126.805L67.3433 126.802C67.3113 126.799 67.2816 126.794 67.2519 126.79C67.1957 126.782 67.1385 126.772 67.0812 126.759C67.0328 126.749 66.9832 126.738 66.9348 126.724C66.904 126.715 66.8743 126.707 66.8456 126.698C66.7201 126.66 66.5957 126.612 66.4757 126.554C66.4592 126.548 66.4438 126.538 66.4273 126.53H66.2599L65.7909 126.094L65.7843 126.087C65.6918 126.001 65.606 125.909 65.5267 125.811C65.5069 125.787 65.4871 125.763 65.4673 125.738C65.4617 125.731 65.4573 125.724 65.4518 125.716C65.4265 125.682 65.4001 125.647 65.3759 125.612C65.3759 125.611 65.3759 125.611 65.3759 125.611C65.3704 125.603 65.3649 125.594 65.3594 125.585C65.3373 125.552 65.3153 125.519 65.2944 125.484C65.2625 125.43 65.2184 125.354 65.1744 125.26C65.1733 125.258 65.1722 125.256 65.1711 125.254C65.1535 125.219 65.1381 125.185 65.1238 125.15C65.1094 125.117 65.0962 125.083 65.083 125.049C65.0786 125.037 65.0742 125.026 65.0698 125.015C65.0621 124.995 65.0555 124.973 65.0478 124.952C65.0412 124.932 65.0335 124.911 65.0269 124.891C65.0192 124.864 65.0115 124.84 65.0049 124.817C64.9938 124.775 64.9839 124.738 64.9773 124.71C64.9729 124.694 64.9696 124.678 64.9663 124.663L64.9146 124.516L64.9135 124.329C64.9124 124.315 64.9113 124.3 64.9102 124.286C64.9047 124.21 64.9014 124.139 64.9014 124.067V28.71H74.9288C75.5365 28.71 76.0297 29.2032 76.0297 29.8109Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.431 28.71V124.067C129.431 124.139 129.427 124.214 129.422 124.288C129.418 124.335 129.413 124.382 129.406 124.428C129.404 124.45 129.4 124.477 129.395 124.505C129.352 124.769 129.273 125.023 129.159 125.258C129.141 125.297 129.122 125.333 129.101 125.372C129.066 125.436 129.016 125.527 128.945 125.628C128.903 125.69 128.859 125.748 128.806 125.813L128.79 125.832C128.778 125.847 128.765 125.863 128.751 125.877L128.709 125.928L128.664 125.972C128.65 125.987 128.638 126 128.625 126.014C128.562 126.075 128.499 126.132 128.436 126.184C128.406 126.211 128.374 126.236 128.342 126.26C128.199 126.367 128.046 126.462 127.885 126.541C127.838 126.564 127.79 126.586 127.744 126.605C127.651 126.643 127.558 126.677 127.461 126.706L127.419 126.723L127.295 126.75C127.243 126.761 127.186 126.773 127.12 126.783L127.001 126.806L126.937 126.807H126.931C126.84 126.816 126.756 126.819 126.673 126.819H118.302V29.8109C118.302 29.2032 118.795 28.71 119.403 28.71H129.431Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.779 15.5023V123.069C127.779 123.105 127.778 123.142 127.776 123.178C127.776 123.189 127.775 123.199 127.774 123.21V123.214C127.774 123.221 127.773 123.226 127.773 123.233C127.771 123.256 127.768 123.28 127.766 123.303C127.758 123.374 127.747 123.443 127.733 123.511C127.729 123.536 127.722 123.561 127.717 123.585C127.713 123.598 127.71 123.611 127.707 123.624C127.699 123.651 127.691 123.679 127.682 123.705C127.664 123.769 127.641 123.831 127.615 123.891V123.892C127.611 123.902 127.607 123.913 127.602 123.923C127.591 123.947 127.581 123.971 127.569 123.994C127.568 123.996 127.567 123.999 127.566 124.001C127.551 124.031 127.536 124.061 127.521 124.089C127.492 124.142 127.461 124.194 127.428 124.244C127.426 124.248 127.423 124.251 127.42 124.256C127.417 124.261 127.413 124.267 127.409 124.272C127.391 124.299 127.373 124.324 127.353 124.349C127.337 124.371 127.32 124.393 127.304 124.414C127.293 124.427 127.283 124.44 127.273 124.452C127.237 124.493 127.2 124.534 127.162 124.573C127.123 124.611 127.084 124.649 127.042 124.684C127.022 124.703 127.001 124.72 126.979 124.737C126.948 124.762 126.915 124.787 126.882 124.812C126.871 124.819 126.859 124.827 126.848 124.835C126.825 124.85 126.802 124.866 126.779 124.88C126.76 124.892 126.74 124.904 126.72 124.915C126.68 124.939 126.639 124.963 126.596 124.983C126.572 124.996 126.547 125.008 126.522 125.019C126.499 125.03 126.475 125.041 126.451 125.051C126.421 125.063 126.391 125.074 126.36 125.085C126.335 125.094 126.311 125.102 126.285 125.11C126.264 125.117 126.244 125.123 126.223 125.129C126.201 125.135 126.179 125.141 126.157 125.146C126.122 125.155 126.087 125.163 126.052 125.169H67.6492C67.6128 125.169 67.5776 125.167 67.5424 125.164C67.5236 125.162 67.5049 125.16 67.4873 125.156C67.4653 125.154 67.4433 125.15 67.4213 125.144C67.4069 125.142 67.3937 125.139 67.3794 125.134C67.3629 125.13 67.3453 125.125 67.3288 125.12C67.2759 125.105 67.2264 125.085 67.1779 125.06C67.1625 125.054 67.1471 125.046 67.1317 125.037C67.0513 124.994 66.9776 124.942 66.9104 124.88C66.8455 124.819 66.7871 124.751 66.7376 124.676C66.7288 124.664 66.7211 124.652 66.7133 124.639C66.6946 124.608 66.677 124.577 66.6627 124.545C66.655 124.53 66.6473 124.513 66.6407 124.497C66.633 124.48 66.6264 124.464 66.6209 124.447C66.6143 124.431 66.6088 124.414 66.6033 124.397C66.5944 124.369 66.5878 124.342 66.5812 124.314C66.5779 124.302 66.5757 124.29 66.5735 124.278C66.5713 124.263 66.568 124.25 66.5669 124.236C66.5658 124.233 66.5658 124.23 66.5658 124.227C66.5636 124.219 66.5636 124.211 66.5625 124.202C66.5603 124.193 66.5592 124.183 66.5592 124.174C66.5559 124.139 66.5537 124.104 66.5537 124.069V15.5023C66.5537 15.4671 66.5559 15.4318 66.5592 15.3966C66.5592 15.3878 66.5603 15.3779 66.5625 15.3691C66.5636 15.357 66.5647 15.346 66.5669 15.335C66.568 15.3207 66.5713 15.3074 66.5735 15.2931C66.5757 15.281 66.5779 15.2689 66.5812 15.2568C66.5878 15.2293 66.5944 15.2018 66.6033 15.1742C66.6088 15.1566 66.6143 15.1401 66.6209 15.1236C66.6264 15.1071 66.633 15.0906 66.6407 15.074C66.6473 15.0575 66.655 15.041 66.6627 15.0256C66.677 14.9937 66.6946 14.9628 66.7133 14.932C66.7211 14.9188 66.7288 14.9067 66.7376 14.8946C66.8367 14.7438 66.9721 14.6194 67.1317 14.5335C67.1471 14.5247 67.1625 14.517 67.1779 14.5104C67.2264 14.4861 67.2759 14.4663 67.3288 14.4509C67.3453 14.4454 67.3629 14.441 67.3794 14.4366C67.3937 14.4322 67.4069 14.4289 67.4213 14.4267C67.4433 14.4212 67.4653 14.4168 67.4873 14.4146C67.5049 14.4113 67.5236 14.4091 67.5424 14.4069C67.5776 14.4036 67.6128 14.4014 67.6492 14.4014H126.673C126.711 14.4014 126.749 14.4036 126.785 14.4069C126.803 14.4091 126.819 14.4113 126.837 14.4135C126.84 14.4135 126.842 14.4146 126.846 14.4146C126.878 14.419 126.909 14.4256 126.938 14.4322V14.4333C126.944 14.4333 126.948 14.4344 126.954 14.4366C127.007 14.4498 127.058 14.4674 127.107 14.4883C127.123 14.4949 127.14 14.5027 127.155 14.5104C127.223 14.5434 127.288 14.583 127.349 14.6293C127.361 14.6381 127.372 14.648 127.384 14.6579C127.409 14.6788 127.434 14.7008 127.457 14.7239C127.469 14.7361 127.48 14.7482 127.492 14.7603C127.504 14.7746 127.516 14.7878 127.528 14.8021C127.548 14.8263 127.567 14.8505 127.585 14.877C127.609 14.9111 127.63 14.9474 127.649 14.9838C127.657 14.9981 127.664 15.0113 127.67 15.0256C127.718 15.1214 127.75 15.226 127.766 15.335C127.768 15.346 127.769 15.357 127.771 15.3691C127.773 15.3779 127.774 15.3878 127.774 15.3966C127.777 15.4307 127.779 15.4671 127.779 15.5023Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.449 15.5031V123.07C127.449 123.937 126.837 124.664 126.021 124.84C125.898 124.866 125.77 124.881 125.638 124.881H66.9105C66.8456 124.82 66.7872 124.752 66.7377 124.677C66.7289 124.665 66.7212 124.653 66.7134 124.64C66.6947 124.609 66.6771 124.578 66.6628 124.546C66.6551 124.531 66.6474 124.514 66.6408 124.498C66.6331 124.481 66.6265 124.465 66.621 124.448C66.6144 124.432 66.6089 124.415 66.6034 124.397C66.5945 124.37 66.5879 124.342 66.5813 124.315C66.578 124.303 66.5758 124.291 66.5736 124.278C66.5714 124.264 66.5681 124.251 66.567 124.237C66.5659 124.233 66.5659 124.231 66.5659 124.228C66.6232 124.121 66.6727 124.009 66.7123 123.893C66.7245 123.865 66.7333 123.835 66.7421 123.805C66.7443 123.797 66.7465 123.79 66.7498 123.781C66.7586 123.753 66.7663 123.725 66.774 123.696C66.7916 123.628 66.807 123.558 66.8191 123.489C66.8235 123.463 66.8279 123.436 66.8301 123.409C66.8346 123.381 66.8379 123.354 66.8412 123.326C66.8445 123.293 66.8478 123.258 66.8489 123.224C66.8533 123.173 66.8544 123.121 66.8544 123.07V112.85H66.8841V15.5031C66.8841 15.4767 66.8852 15.4502 66.8885 15.4249C66.8907 15.4018 66.894 15.3798 66.8984 15.3578C66.9006 15.3434 66.9039 15.3291 66.9072 15.3159C66.9072 15.3148 66.9083 15.3148 66.9083 15.3148C66.9083 15.3137 66.9083 15.3137 66.9083 15.3137C66.9094 15.3049 66.9127 15.2961 66.9149 15.2873C66.9215 15.2653 66.9292 15.2422 66.938 15.2212C66.9446 15.2036 66.9513 15.1871 66.9601 15.1706C66.9623 15.164 66.9656 15.1574 66.97 15.1508C66.9777 15.1354 66.9865 15.12 66.9953 15.1045C66.9986 15.1001 67.0008 15.0957 67.0041 15.0913C67.0129 15.077 67.0228 15.0616 67.0338 15.0473C67.0382 15.0418 67.0426 15.0363 67.047 15.0308C67.0558 15.0187 67.0657 15.0066 67.0779 14.9944C67.0812 14.9889 67.0867 14.9834 67.0911 14.979C67.101 14.9669 67.112 14.9559 67.123 14.946C67.1318 14.9372 67.1417 14.9284 67.1516 14.9196C67.1593 14.9141 67.1659 14.9075 67.1736 14.902C67.1891 14.8888 67.2067 14.8766 67.2243 14.8645C67.243 14.8513 67.2617 14.8403 67.2815 14.8304C67.308 14.815 67.3344 14.8018 67.3619 14.7908C67.3828 14.782 67.4037 14.7743 67.4258 14.7676C67.4324 14.7654 67.4379 14.7632 67.4445 14.7632C67.4445 14.7632 67.4445 14.7621 67.4456 14.7621C67.4511 14.7599 67.4566 14.7588 67.4621 14.7577C67.4984 14.7478 67.5369 14.7401 67.5766 14.7368C67.5997 14.7335 67.625 14.7324 67.6492 14.7324H126.684C126.703 14.7324 126.721 14.7335 126.74 14.7357C126.743 14.7357 126.748 14.7368 126.751 14.7368C126.775 14.739 126.8 14.7423 126.824 14.7467C126.841 14.75 126.858 14.7544 126.874 14.7588C126.878 14.7588 126.88 14.7599 126.882 14.761C126.912 14.7688 126.941 14.7776 126.969 14.7897C126.978 14.793 126.988 14.7974 126.997 14.8018C127.012 14.8084 127.028 14.8161 127.043 14.8249C127.045 14.826 127.047 14.8271 127.05 14.8282C127.069 14.8381 127.088 14.8502 127.106 14.8623C127.108 14.8634 127.111 14.8656 127.113 14.8678C127.131 14.8788 127.148 14.8921 127.164 14.9053C127.167 14.9075 127.171 14.9108 127.174 14.9141C127.187 14.924 127.2 14.9361 127.212 14.9482C127.22 14.9548 127.227 14.9614 127.233 14.9691C127.244 14.9801 127.254 14.9911 127.264 15.0033C127.27 15.0099 127.275 15.0154 127.28 15.0209C127.288 15.0319 127.296 15.0429 127.304 15.0539C127.313 15.0649 127.319 15.0759 127.327 15.0869C127.331 15.0935 127.335 15.099 127.338 15.1056C127.348 15.1211 127.358 15.1376 127.366 15.1552C127.375 15.1728 127.383 15.1915 127.391 15.2102C127.396 15.2212 127.401 15.2333 127.404 15.2455C127.41 15.2587 127.414 15.2708 127.417 15.284C127.422 15.2983 127.426 15.3126 127.428 15.328L127.429 15.3291C127.432 15.3379 127.434 15.3478 127.435 15.3567C127.439 15.3787 127.443 15.4018 127.445 15.4249C127.448 15.4502 127.449 15.4767 127.449 15.5031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1684 49.5965C100.332 49.5965 103.415 48.4875 105.851 46.4738C108.996 43.8722 110.799 40.0422 110.799 35.9657C110.799 28.4497 104.684 22.335 97.1684 22.335C89.6524 22.335 83.5376 28.4497 83.5376 35.9657C83.5376 40.0429 85.3417 43.8729 88.4872 46.4738C90.9198 48.4874 94.0031 49.5965 97.1684 49.5965Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6377 35.9664C84.6377 39.8538 86.4091 43.3284 89.1879 45.626C91.3546 47.4195 94.1366 48.4962 97.1675 48.4962C100.2 48.4962 102.981 47.4184 105.148 45.626C107.927 43.3273 109.697 39.8538 109.697 35.9664C109.697 29.0469 104.087 23.4365 97.1675 23.4365C90.2481 23.4365 84.6377 29.0469 84.6377 35.9664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1885 39.9578V45.6254C91.3551 47.4188 94.1372 48.4956 97.1681 48.4956C100.2 48.4956 102.981 47.4177 105.149 45.6254V39.9578L99.4603 37.4608L97.4742 36.5889L94.876 37.6458L89.1885 39.9578Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2504 31.5993V30.6963H100.085V31.5993C100.354 31.5993 100.572 31.8169 100.572 32.0856V33.8917C100.572 34.1602 100.354 34.378 100.085 34.378V34.8642C100.085 35.5446 99.8506 36.169 99.4602 36.6652V38.7311C99.4602 39.9971 98.4339 41.0235 97.1679 41.0235C95.902 41.0235 94.8757 39.9972 94.8757 38.7311V36.665C94.4853 36.1689 94.2504 35.5444 94.2504 34.8641V34.3778C93.9819 34.3778 93.7642 34.1602 93.7642 33.8916V32.0855C93.7642 31.8169 93.9819 31.5993 94.2504 31.5993Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3604 27.8477H97.9758C99.2244 27.8477 100.236 29.1773 100.236 30.8175V33.1322L99.8018 30.8257C98.3377 32.1996 95.9985 32.1996 94.5343 30.8257L94.0996 33.1322V30.8175C94.0997 29.1773 95.1118 27.8477 96.3604 27.8477Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6879 57.3406H120.647C121.301 57.3406 121.831 56.8105 121.831 56.1566C121.831 55.5028 121.301 54.9727 120.647 54.9727H73.6879C73.034 54.9727 72.5039 55.5028 72.5039 56.1566C72.5039 56.8105 73.034 57.3406 73.6879 57.3406Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 63.7576H120.647C121.301 63.7576 121.831 63.2274 121.831 62.5736C121.831 61.9197 121.301 61.3896 120.647 61.3896H73.6874C73.0335 61.3896 72.5034 61.9197 72.5034 62.5736C72.5034 63.2276 73.0335 63.7576 73.6874 63.7576Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 70.1716H120.647C121.301 70.1716 121.831 69.6415 121.831 68.9877C121.831 68.3338 121.301 67.8037 120.647 67.8037H73.6874C73.0335 67.8037 72.5034 68.3338 72.5034 68.9877C72.5034 69.6415 73.0335 70.1716 73.6874 70.1716Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 76.5847H120.647C121.301 76.5847 121.831 76.0546 121.831 75.4007C121.831 74.7469 121.301 74.2168 120.647 74.2168H73.6874C73.0335 74.2168 72.5034 74.7469 72.5034 75.4007C72.5034 76.0547 73.0335 76.5847 73.6874 76.5847Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 82.9997H120.647C121.301 82.9997 121.831 82.4696 121.831 81.8158C121.831 81.1619 121.301 80.6318 120.647 80.6318H73.6874C73.0335 80.6318 72.5034 81.1619 72.5034 81.8158C72.5034 82.4696 73.0335 82.9997 73.6874 82.9997Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 89.4138H120.647C121.301 89.4138 121.831 88.8837 121.831 88.2298C121.831 87.576 121.301 87.0459 120.647 87.0459H73.6874C73.0335 87.0459 72.5034 87.576 72.5034 88.2298C72.5034 88.8837 73.0335 89.4138 73.6874 89.4138Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 95.8279H120.647C121.301 95.8279 121.831 95.2978 121.831 94.6439C121.831 93.9901 121.301 93.46 120.647 93.46H73.6874C73.0335 93.46 72.5034 93.9901 72.5034 94.6439C72.5034 95.2979 73.0335 95.8279 73.6874 95.8279Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 102.244H120.647C121.301 102.244 121.831 101.714 121.831 101.06C121.831 100.406 121.301 99.876 120.647 99.876H73.6874C73.0335 99.876 72.5034 100.406 72.5034 101.06C72.5034 101.714 73.0335 102.244 73.6874 102.244Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 108.658H120.647C121.301 108.658 121.831 108.128 121.831 107.474C121.831 106.82 121.301 106.29 120.647 106.29H73.6874C73.0335 106.29 72.5034 106.82 72.5034 107.474C72.5034 108.128 73.0335 108.658 73.6874 108.658Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 115.073H120.647C121.301 115.073 121.831 114.543 121.831 113.889C121.831 113.235 121.301 112.705 120.647 112.705H73.6874C73.0335 112.705 72.5034 113.235 72.5034 113.889C72.5034 114.543 73.0335 115.073 73.6874 115.073Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.779 16.502V124.069C127.779 124.104 127.777 124.14 127.774 124.174C127.774 124.183 127.773 124.193 127.771 124.202C127.769 124.214 127.768 124.225 127.766 124.236C127.75 124.345 127.718 124.449 127.67 124.545C127.664 124.56 127.657 124.573 127.649 124.587C127.63 124.623 127.609 124.66 127.585 124.694C127.567 124.72 127.548 124.745 127.528 124.769C127.516 124.783 127.504 124.796 127.492 124.811C127.48 124.823 127.469 124.835 127.457 124.847C127.434 124.87 127.409 124.892 127.384 124.913C127.372 124.923 127.361 124.933 127.349 124.942C127.288 124.988 127.223 125.027 127.155 125.06C127.14 125.068 127.123 125.076 127.107 125.083C127.058 125.103 127.007 125.121 126.954 125.134C126.949 125.135 126.944 125.136 126.938 125.139C126.909 125.145 126.878 125.152 126.846 125.156C126.842 125.156 126.84 125.157 126.837 125.157C126.819 125.16 126.803 125.162 126.785 125.164C126.749 125.167 126.711 125.169 126.673 125.169H67.6492C67.6128 125.169 67.5776 125.167 67.5424 125.164C67.5236 125.162 67.5049 125.16 67.4873 125.156C67.4653 125.154 67.4433 125.15 67.4213 125.144C67.4069 125.142 67.3937 125.139 67.3794 125.134C67.3629 125.13 67.3453 125.125 67.3288 125.12C67.2759 125.105 67.2264 125.085 67.1779 125.06C67.1625 125.054 67.1471 125.046 67.1317 125.037C67.0513 124.994 66.9776 124.942 66.9104 124.88C66.8455 124.819 66.7871 124.751 66.7376 124.676C66.7288 124.664 66.7211 124.652 66.7133 124.639C66.6946 124.608 66.677 124.577 66.6627 124.545C66.655 124.53 66.6473 124.513 66.6407 124.497C66.633 124.48 66.6264 124.464 66.6209 124.447C66.6143 124.431 66.6088 124.414 66.6033 124.397C66.5944 124.369 66.5878 124.342 66.5812 124.314C66.5779 124.302 66.5757 124.29 66.5735 124.278C66.5713 124.263 66.568 124.25 66.5669 124.236C66.5658 124.233 66.5658 124.23 66.5658 124.227C66.5636 124.219 66.5636 124.211 66.5625 124.202C66.5603 124.193 66.5592 124.183 66.5592 124.174C66.5559 124.139 66.5537 124.104 66.5537 124.069V16.3566C66.5691 16.1177 66.6242 15.8887 66.7122 15.6785C66.7662 15.5507 66.8312 15.4285 66.9071 15.3151C66.9071 15.314 66.9082 15.314 66.9082 15.314C66.9082 15.3129 66.9082 15.3129 66.9082 15.3129C67.0524 15.0983 67.2341 14.9111 67.4444 14.7625C67.4444 14.7625 67.4444 14.7614 67.4455 14.7614C67.4796 14.7361 67.5137 14.7129 67.549 14.6909C67.7669 14.5522 68.0125 14.452 68.2756 14.4014H126.052C126.087 14.408 126.122 14.4157 126.157 14.4245C126.179 14.43 126.201 14.4355 126.223 14.4421C126.244 14.4476 126.264 14.4542 126.285 14.4608C126.311 14.4685 126.335 14.4773 126.36 14.4861C126.391 14.4971 126.421 14.5082 126.451 14.5203C126.475 14.5302 126.499 14.5412 126.522 14.5522C126.547 14.5632 126.572 14.5753 126.596 14.5874C126.639 14.6083 126.68 14.6315 126.72 14.6557C126.74 14.6667 126.76 14.6788 126.779 14.6909C126.802 14.7052 126.825 14.7206 126.848 14.7361C126.859 14.7438 126.871 14.7515 126.882 14.7603C126.915 14.7834 126.948 14.8087 126.979 14.834C127.001 14.8506 127.022 14.8682 127.042 14.8869C127.084 14.9221 127.123 14.9595 127.162 14.9981C127.2 15.0366 127.237 15.0773 127.273 15.1192C127.283 15.1313 127.293 15.1434 127.304 15.1566C127.32 15.1775 127.337 15.1995 127.353 15.2216C127.373 15.2469 127.391 15.2722 127.409 15.2986C127.413 15.3041 127.417 15.3096 127.42 15.3151C127.423 15.3196 127.426 15.3229 127.428 15.3273L127.429 15.3284C127.461 15.3779 127.492 15.4285 127.521 15.4814C127.536 15.51 127.551 15.5397 127.566 15.5695C127.567 15.5717 127.568 15.575 127.569 15.5772C127.581 15.6003 127.591 15.6234 127.602 15.6476C127.607 15.6575 127.611 15.6686 127.615 15.6785V15.6796C127.641 15.7401 127.664 15.8018 127.682 15.8656C127.691 15.892 127.699 15.9196 127.707 15.9471C127.71 15.9603 127.713 15.9724 127.717 15.9856C127.722 16.0098 127.729 16.0352 127.733 16.0594C127.747 16.1276 127.758 16.197 127.766 16.2675C127.768 16.2906 127.771 16.3148 127.773 16.3379C127.773 16.3445 127.774 16.35 127.774 16.3566V16.361C127.775 16.3721 127.776 16.382 127.776 16.393C127.778 16.4293 127.779 16.4656 127.779 16.502Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.449 124.069V16.5025C127.449 15.5039 126.638 14.6914 125.638 14.6914H67.5491C67.1781 14.9248 66.883 15.2694 66.7124 15.679C66.8049 15.9366 66.8544 16.214 66.8544 16.5025V26.7225H66.8841V124.069C66.8841 124.468 67.188 124.796 67.5766 124.835C67.6009 124.839 67.6251 124.84 67.6493 124.84H126.673C126.7 124.84 126.726 124.839 126.751 124.835C127.142 124.8 127.449 124.47 127.449 124.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.779 15.5023V120.803H123.412V125.169H68.2756C68.0125 125.119 67.7669 125.019 67.549 124.88C67.5137 124.858 67.4796 124.835 67.4455 124.809C67.2352 124.66 67.0524 124.473 66.9082 124.258C66.8322 124.143 66.7662 124.021 66.7122 123.892C66.6242 123.682 66.5691 123.453 66.5537 123.214V15.5023C66.5537 15.4671 66.5559 15.4318 66.5592 15.3966C66.5592 15.3878 66.5603 15.3779 66.5625 15.3691C66.5636 15.357 66.5647 15.346 66.5669 15.335C66.568 15.3207 66.5713 15.3074 66.5735 15.2931C66.5757 15.281 66.5779 15.2689 66.5812 15.2568C66.5878 15.2293 66.5944 15.2018 66.6033 15.1742C66.6088 15.1566 66.6143 15.1401 66.6209 15.1236C66.6264 15.1071 66.633 15.0906 66.6407 15.074C66.6473 15.0575 66.655 15.041 66.6627 15.0256C66.677 14.9937 66.6946 14.9628 66.7133 14.932C66.7211 14.9188 66.7288 14.9067 66.7376 14.8946C66.8367 14.7438 66.9721 14.6194 67.1317 14.5335C67.1471 14.5247 67.1625 14.517 67.1779 14.5104C67.2264 14.4861 67.2759 14.4663 67.3288 14.4509C67.3453 14.4454 67.3629 14.441 67.3794 14.4366C67.3937 14.4322 67.4069 14.4289 67.4213 14.4267C67.4433 14.4212 67.4653 14.4168 67.4873 14.4146C67.5049 14.4113 67.5236 14.4091 67.5424 14.4069C67.5776 14.4036 67.6128 14.4014 67.6492 14.4014H126.673C126.711 14.4014 126.749 14.4036 126.785 14.4069C126.803 14.4091 126.819 14.4113 126.837 14.4135C126.84 14.4135 126.842 14.4146 126.846 14.4146C126.878 14.419 126.909 14.4256 126.938 14.4322C126.944 14.4344 126.949 14.4355 126.954 14.4366C127.007 14.4498 127.058 14.4674 127.107 14.4883C127.123 14.4949 127.14 14.5027 127.155 14.5104C127.223 14.5434 127.288 14.583 127.349 14.6293C127.361 14.6381 127.372 14.648 127.384 14.6579C127.409 14.6788 127.434 14.7008 127.457 14.7239C127.469 14.7361 127.48 14.7482 127.492 14.7603C127.504 14.7746 127.516 14.7878 127.528 14.8021C127.548 14.8263 127.567 14.8505 127.585 14.877C127.609 14.9111 127.63 14.9474 127.649 14.9838C127.657 14.9981 127.664 15.0113 127.67 15.0256C127.718 15.1214 127.75 15.226 127.766 15.335C127.768 15.346 127.769 15.357 127.771 15.3691C127.773 15.3779 127.774 15.3878 127.774 15.3966C127.777 15.4307 127.779 15.4671 127.779 15.5023Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.449 15.5031V123.07C127.449 124.068 126.638 124.881 125.638 124.881H67.5491C67.1781 124.647 66.883 124.303 66.7124 123.893C66.8049 123.636 66.8544 123.358 66.8544 123.07V112.85H66.8841V15.5031C66.8841 15.1045 67.188 14.7765 67.5766 14.7368C67.6009 14.7335 67.6251 14.7324 67.6493 14.7324H126.673C126.7 14.7324 126.726 14.7335 126.751 14.7368C127.142 14.7721 127.449 15.1023 127.449 15.5031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1684 49.5965C100.332 49.5965 103.415 48.4875 105.851 46.4738C108.996 43.8722 110.799 40.0422 110.799 35.9657C110.799 28.4497 104.684 22.335 97.1684 22.335C89.6524 22.335 83.5376 28.4497 83.5376 35.9657C83.5376 40.0429 85.3417 43.8729 88.4872 46.4738C90.9198 48.4874 94.0031 49.5965 97.1684 49.5965Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6377 35.9664C84.6377 39.8538 86.4091 43.3284 89.1879 45.626C91.3546 47.4195 94.1366 48.4962 97.1675 48.4962C100.2 48.4962 102.981 47.4184 105.148 45.626C107.927 43.3273 109.697 39.8538 109.697 35.9664C109.697 29.0469 104.087 23.4365 97.1675 23.4365C90.2481 23.4365 84.6377 29.0469 84.6377 35.9664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1885 39.9578V45.6254C91.3551 47.4188 94.1372 48.4956 97.1681 48.4956C100.2 48.4956 102.981 47.4177 105.149 45.6254V39.9578L99.4603 37.4608L97.4742 36.5889L94.876 37.6458L89.1885 39.9578Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2504 31.5993V30.6963H100.085V31.5993C100.354 31.5993 100.572 31.8169 100.572 32.0856V33.8917C100.572 34.1602 100.354 34.378 100.085 34.378V34.8642C100.085 35.5446 99.8506 36.169 99.4602 36.6652V38.7311C99.4602 39.9971 98.4339 41.0235 97.1679 41.0235C95.902 41.0235 94.8757 39.9972 94.8757 38.7311V36.665C94.4853 36.1689 94.2504 35.5444 94.2504 34.8641V34.3778C93.9819 34.3778 93.7642 34.1602 93.7642 33.8916V32.0855C93.7642 31.8169 93.9819 31.5993 94.2504 31.5993Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3604 27.8477H97.9758C99.2244 27.8477 100.236 29.1773 100.236 30.8175V33.1322L99.8018 30.8257C98.3377 32.1996 95.9985 32.1996 94.5343 30.8257L94.0996 33.1322V30.8175C94.0997 29.1773 95.1118 27.8477 96.3604 27.8477Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6879 57.3406H120.647C121.301 57.3406 121.831 56.8105 121.831 56.1566C121.831 55.5028 121.301 54.9727 120.647 54.9727H73.6879C73.034 54.9727 72.5039 55.5028 72.5039 56.1566C72.5039 56.8105 73.034 57.3406 73.6879 57.3406Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 63.7576H120.647C121.301 63.7576 121.831 63.2274 121.831 62.5736C121.831 61.9197 121.301 61.3896 120.647 61.3896H73.6874C73.0335 61.3896 72.5034 61.9197 72.5034 62.5736C72.5034 63.2276 73.0335 63.7576 73.6874 63.7576Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 70.1716H120.647C121.301 70.1716 121.831 69.6415 121.831 68.9877C121.831 68.3338 121.301 67.8037 120.647 67.8037H73.6874C73.0335 67.8037 72.5034 68.3338 72.5034 68.9877C72.5034 69.6415 73.0335 70.1716 73.6874 70.1716Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 76.5847H120.647C121.301 76.5847 121.831 76.0546 121.831 75.4007C121.831 74.7469 121.301 74.2168 120.647 74.2168H73.6874C73.0335 74.2168 72.5034 74.7469 72.5034 75.4007C72.5034 76.0547 73.0335 76.5847 73.6874 76.5847Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 82.9997H120.647C121.301 82.9997 121.831 82.4696 121.831 81.8158C121.831 81.1619 121.301 80.6318 120.647 80.6318H73.6874C73.0335 80.6318 72.5034 81.1619 72.5034 81.8158C72.5034 82.4696 73.0335 82.9997 73.6874 82.9997Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 89.4138H120.647C121.301 89.4138 121.831 88.8837 121.831 88.2298C121.831 87.576 121.301 87.0459 120.647 87.0459H73.6874C73.0335 87.0459 72.5034 87.576 72.5034 88.2298C72.5034 88.8837 73.0335 89.4138 73.6874 89.4138Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 95.8279H120.647C121.301 95.8279 121.831 95.2978 121.831 94.6439C121.831 93.9901 121.301 93.46 120.647 93.46H73.6874C73.0335 93.46 72.5034 93.9901 72.5034 94.6439C72.5034 95.2979 73.0335 95.8279 73.6874 95.8279Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 102.244H120.647C121.301 102.244 121.831 101.714 121.831 101.06C121.831 100.406 121.301 99.876 120.647 99.876H73.6874C73.0335 99.876 72.5034 100.406 72.5034 101.06C72.5034 101.714 73.0335 102.244 73.6874 102.244Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 108.658H120.647C121.301 108.658 121.831 108.128 121.831 107.474C121.831 106.82 121.301 106.29 120.647 106.29H73.6874C73.0335 106.29 72.5034 106.82 72.5034 107.474C72.5034 108.128 73.0335 108.658 73.6874 108.658Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 115.073H120.647C121.301 115.073 121.831 114.543 121.831 113.889C121.831 113.235 121.301 112.705 120.647 112.705H73.6874C73.0335 112.705 72.5034 113.235 72.5034 113.889C72.5034 114.543 73.0335 115.073 73.6874 115.073Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6855 7L37.1978 16.0816L34.0586 23.8429L41.1474 20.073L39.9326 17.5715L59.6855 7Z",
    fill: "url(#paint0_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1986 16.0814L28.4082 10.3805L59.6864 7L37.1986 16.0814Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9326 17.5715L44.8548 27.708L59.6855 7L39.9326 17.5715Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.233 72.4619L149.83 74.0513L152.696 77.8082L148.275 76.8133L148.563 75.2703L136.233 72.4619Z",
    fill: "url(#paint1_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83 74.0523L153.765 69.6377L136.234 72.463L149.83 74.0523Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.563 75.2703L147.396 81.5226L136.233 72.4619L148.563 75.2703Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.296 80.1167C155.966 79.9643 155.629 79.82 155.292 79.6884L155.413 79.3809C155.755 79.515 156.099 79.6617 156.435 79.8171L156.296 80.1167Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.396 109.885C184.132 109.229 183.84 108.571 183.528 107.929L183.825 107.785C184.141 108.433 184.436 109.099 184.702 109.762L184.396 109.885ZM182.526 106.037C182.173 105.423 181.794 104.81 181.398 104.218L181.673 104.035C182.072 104.633 182.456 105.252 182.813 105.873L182.526 106.037ZM180.151 102.478C179.719 101.915 179.262 101.359 178.792 100.823L179.041 100.605C179.515 101.146 179.977 101.709 180.413 102.277L180.151 102.478ZM177.329 99.2592C176.827 98.7568 176.302 98.2636 175.768 97.7935L175.986 97.5456C176.526 98.0204 177.056 98.5185 177.563 99.0259L177.329 99.2592ZM157.851 99.0738C157.723 99.0738 157.595 99.0726 157.466 99.0699L157.473 98.7396C157.599 98.7423 157.725 98.7435 157.851 98.7435C158.339 98.7435 158.845 98.7251 159.29 98.709C159.398 98.7052 159.506 98.701 159.615 98.6964L159.629 99.0264C159.519 99.0311 159.411 99.0352 159.302 99.0391C158.854 99.0553 158.345 99.0738 157.851 99.0738ZM161.79 98.8403L161.741 98.5136C162.533 98.3948 163.199 98.218 163.776 97.9732L163.905 98.2772C163.302 98.5331 162.61 98.7172 161.79 98.8403ZM155.297 98.8181C155.213 98.7978 155.129 98.7759 155.045 98.7524C154.405 98.5734 153.796 98.2886 153.283 97.9289L153.473 97.6586C153.955 97.9971 154.53 98.2654 155.134 98.4345C155.214 98.4568 155.294 98.4777 155.375 98.4971L155.297 98.8181ZM165.713 97.0157L165.468 96.7948L165.507 96.7505C165.939 96.2524 166.246 95.6557 166.419 94.9766L166.739 95.0583C166.553 95.7876 166.223 96.4298 165.756 96.9669C165.742 96.9832 165.728 96.9996 165.713 97.0157ZM174.116 96.4313C173.552 95.9966 172.968 95.5753 172.379 95.1792L172.563 94.9051C173.158 95.3052 173.748 95.7308 174.317 96.1698L174.116 96.4313ZM151.844 96.2474C151.818 96.1902 151.793 96.1319 151.771 96.073C151.614 95.6704 151.535 95.2423 151.535 94.8005C151.535 94.5511 151.56 94.296 151.611 94.042L151.934 94.1063C151.888 94.3391 151.865 94.5726 151.865 94.8005C151.865 95.2011 151.937 95.589 152.078 95.9533C152.099 96.0068 152.121 96.0595 152.145 96.1116L151.844 96.2474ZM170.564 94.043C169.947 93.685 169.313 93.3442 168.678 93.0301L168.824 92.7341C169.466 93.0515 170.107 93.3959 170.73 93.7575L170.564 94.043ZM166.561 92.8947C166.536 92.6126 166.495 92.3237 166.44 92.03C165.872 91.8029 165.296 91.5918 164.722 91.4006L164.826 91.0873C165.337 91.2574 165.85 91.4434 166.357 91.6422C166.295 91.3735 166.22 91.1011 166.132 90.8264L166.447 90.7264C166.561 91.0854 166.655 91.4409 166.728 91.7905C166.77 91.8074 166.812 91.8246 166.853 91.8418L166.775 92.0307C166.827 92.3138 166.866 92.5926 166.89 92.8659L166.561 92.8947ZM152.807 92.2423L152.545 92.0408C153.001 91.4489 153.579 90.9507 154.215 90.6L154.374 90.8893C153.777 91.2182 153.235 91.686 152.807 92.2423ZM162.668 90.7981C162.108 90.6552 161.537 90.5276 160.972 90.4189C160.841 90.3937 160.709 90.3694 160.577 90.3463L160.634 90.0209C160.768 90.0445 160.902 90.0692 161.035 90.0947C161.606 90.2046 162.183 90.3336 162.75 90.4782L162.668 90.7981ZM156.353 90.2204L156.296 89.8951C156.961 89.7781 157.691 89.737 158.476 89.7712L158.462 90.1013C157.701 90.0677 156.994 90.1075 156.353 90.2204ZM165.318 88.8639C165.003 88.2332 164.646 87.6112 164.257 87.015L164.533 86.8344C164.929 87.4412 165.293 88.0744 165.614 88.7162L165.318 88.8639ZM162.992 85.2977C162.541 84.7518 162.054 84.2247 161.545 83.7308L161.774 83.4937C162.293 83.9959 162.788 84.5321 163.247 85.0873L162.992 85.2977ZM159.933 82.3328C159.372 81.8973 158.781 81.4899 158.178 81.1218L158.35 80.8398C158.964 81.2143 159.565 81.6288 160.136 82.0718L159.933 82.3328Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.44 112.96C185.342 112.611 185.237 112.258 185.125 111.911L185.44 111.811C185.552 112.162 185.659 112.519 185.758 112.871L185.44 112.96Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.477 86.7103C26.9142 86.2428 26.3599 85.7456 25.8292 85.2327L26.0588 84.9952C26.5835 85.5024 27.1316 85.9939 27.6881 86.4563L27.477 86.7103ZM24.2956 83.6369C23.808 83.091 23.3322 82.5182 22.8816 81.9344L23.143 81.7326C23.5888 82.3102 24.0596 82.8768 24.5419 83.417L24.2956 83.6369ZM21.5917 80.1363C21.1857 79.5265 20.7947 78.8929 20.4295 78.253L20.7163 78.0893C21.0777 78.7225 21.4646 79.3497 21.8665 79.9532L21.5917 80.1363ZM19.3988 76.2949C19.079 75.6339 18.7776 74.953 18.5029 74.2717L18.8092 74.1481C19.0811 74.8227 19.3796 75.4966 19.6961 76.151L19.3988 76.2949ZM17.7449 72.1929C17.5163 71.4936 17.309 70.7787 17.1287 70.0678L17.4488 69.9866C17.6274 70.6903 17.8326 71.398 18.0588 72.0902L17.7449 72.1929ZM16.6577 67.9059C16.5256 67.1811 16.4175 66.4445 16.3362 65.7166L16.6644 65.6799C16.7448 66.4003 16.8519 67.1293 16.9826 67.8467L16.6577 67.9059ZM16.1682 63.51C16.1512 63.0925 16.1426 62.6701 16.1426 62.2547C16.1426 61.9357 16.1476 61.6134 16.1576 61.2968L16.4877 61.3072C16.4779 61.6204 16.473 61.9391 16.4729 62.2547C16.4729 62.6656 16.4814 63.0834 16.4982 63.4966L16.1682 63.51ZM16.6368 59.1231L16.3084 59.0884C16.386 58.3544 16.4921 57.6171 16.6238 56.8972L16.9487 56.9567C16.8184 57.6683 16.7135 58.3973 16.6368 59.1231ZM24.36 55.8861C24.1758 55.8794 23.9924 55.8603 23.8147 55.8288C23.2568 55.7302 22.7139 55.5232 22.2012 55.2134L22.372 54.9308C22.8497 55.2195 23.3544 55.4122 23.8722 55.5035C24.0349 55.5323 24.203 55.5499 24.372 55.5561L24.36 55.8861ZM26.5616 55.3576L26.4012 55.0688C27.0476 54.7097 27.533 54.1945 27.8045 53.579L28.1119 53.7005L28.1065 53.713C27.8059 54.3942 27.2716 54.9632 26.5616 55.3576ZM17.4408 54.8284L17.1236 54.7362C17.3482 53.9639 17.6046 53.2822 17.9075 52.6521L18.2052 52.7952C17.9103 53.4088 17.6601 54.0737 17.4408 54.8284ZM20.5487 53.6826C20.3353 53.3912 20.1466 53.0795 19.9878 52.7564C19.8176 52.4098 19.6737 52.0425 19.5602 51.6646L19.8765 51.5695C19.9849 51.9302 20.122 52.2805 20.2842 52.6108C20.4345 52.9167 20.6131 53.2116 20.8151 53.4875L20.5487 53.6826ZM27.9166 51.525C27.7328 50.8717 27.3499 50.2345 26.8384 49.7309L27.0701 49.4955C27.6218 50.0388 28.0353 50.7276 28.2345 51.4354L27.9166 51.525ZM19.3533 50.9688L19.0975 50.7598C19.1249 50.7262 19.1527 50.6929 19.1806 50.6597C19.6377 50.1185 20.173 49.6491 20.7716 49.2643L20.9502 49.542C20.3792 49.909 19.8688 50.3567 19.433 50.8728C19.4061 50.9046 19.3796 50.9365 19.3533 50.9688ZM19.2203 49.4515C19.2178 49.3596 19.2166 49.2677 19.2166 49.1755C19.2166 48.5646 19.2709 47.9095 19.3778 47.2282L19.7041 47.2794C19.5999 47.9438 19.5469 48.5818 19.5469 49.1756C19.5469 49.2648 19.5481 49.3539 19.5504 49.4429L19.2203 49.4515ZM22.9132 48.7089L22.8417 48.3864C23.6106 48.2157 24.3819 48.215 25.0984 48.3844L25.0225 48.7058C24.3542 48.5478 23.6337 48.5491 22.9132 48.7089ZM20.1781 45.1501L19.86 45.0609C19.9515 44.7343 20.0557 44.3903 20.1695 44.0381C20.286 43.6775 20.4095 43.3129 20.5367 42.9543L20.848 43.0646C20.7218 43.4204 20.5994 43.782 20.4838 44.1397C20.3714 44.4877 20.2685 44.8277 20.1781 45.1501ZM21.6362 41.0184L21.3312 40.8915C21.6124 40.2161 21.9164 39.5373 22.2347 38.8742L22.5323 39.0171C22.2167 39.6749 21.915 40.3483 21.6362 41.0184ZM23.5329 37.0658L23.243 36.9075C23.5941 36.2647 23.9673 35.6215 24.3524 34.9958L24.6337 35.1689C24.2516 35.7897 23.8812 36.4279 23.5329 37.0658ZM25.831 33.3313L25.5589 33.1439C25.9747 32.5403 26.4121 31.939 26.8587 31.3564L27.1209 31.5575C26.6775 32.1356 26.2435 32.7324 25.831 33.3313ZM28.4997 29.8521L28.2482 29.638C28.7239 29.0793 29.2204 28.5256 29.7235 27.9924L29.9637 28.2192C29.4644 28.7481 28.9719 29.2975 28.4997 29.8521ZM31.5093 26.663L31.2811 26.4243C31.812 25.9167 32.3626 25.4167 32.9173 24.9385L33.133 25.1886C32.5824 25.6632 32.0361 26.1593 31.5093 26.663ZM34.8307 23.8006L34.6283 23.5395C35.2094 23.0891 35.8089 22.6492 36.4103 22.2319L36.5985 22.5033C36.0021 22.9172 35.4072 23.3537 34.8307 23.8006ZM38.4328 21.3014L38.2593 21.0203C38.8849 20.634 39.528 20.2605 40.1708 19.9102L40.3288 20.2001C39.6913 20.5477 39.0533 20.9183 38.4328 21.3014Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.458 167.495H1.18833C0.532015 167.495 0 166.933 0 166.24C0 165.547 0.532015 164.985 1.18833 164.985H193.458C194.114 164.985 194.646 165.547 194.646 166.24C194.646 166.933 194.114 167.495 193.458 167.495Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2761_30850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7777 159.442H41.8481C41.6092 159.442 41.4155 159.645 41.4155 159.896V163.286C41.4155 163.536 41.6092 163.739 41.8481 163.739H63.7777C64.0167 163.739 64.2103 163.536 64.2103 163.286V159.896C64.2103 159.645 64.0167 159.442 63.7777 159.442Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4155 163.283C41.4155 163.533 41.6092 163.736 41.8481 163.736H63.7777C64.0167 163.736 64.2103 163.533 64.2103 163.283H41.4155Z",
    fill: "url(#paint2_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4155 159.898C41.4155 159.647 41.6092 159.444 41.8481 159.444H63.7777C64.0167 159.444 64.2103 159.647 64.2103 159.898H41.4155Z",
    fill: "url(#paint3_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1014 160.281H52.5239V162.903H53.1014V160.281Z",
    fill: "url(#paint4_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4393 160.281H50.8618V162.903H51.4393V160.281Z",
    fill: "url(#paint5_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7767 160.281H49.1992V162.903H49.7767V160.281Z",
    fill: "url(#paint6_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1141 160.281H47.5366V162.903H48.1141V160.281Z",
    fill: "url(#paint7_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.451 160.281H45.8735V162.903H46.451V160.281Z",
    fill: "url(#paint8_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7889 160.281H44.2114V162.903H44.7889V160.281Z",
    fill: "url(#paint9_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1263 160.281H42.5488V162.903H43.1263V160.281Z",
    fill: "url(#paint10_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0775 160.281H62.5V162.903H63.0775V160.281Z",
    fill: "url(#paint11_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4149 160.281H60.8374V162.903H61.4149V160.281Z",
    fill: "url(#paint12_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7518 160.281H59.1743V162.903H59.7518V160.281Z",
    fill: "url(#paint13_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0897 160.281H57.5122V162.903H58.0897V160.281Z",
    fill: "url(#paint14_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4271 160.281H55.8496V162.903H56.4271V160.281Z",
    fill: "url(#paint15_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7645 160.281H54.187V162.903H54.7645V160.281Z",
    fill: "url(#paint16_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.517 155.145H41.5874C41.3485 155.145 41.1548 155.347 41.1548 155.598V158.988C41.1548 159.239 41.3485 159.441 41.5874 159.441H63.517C63.7559 159.441 63.9496 159.239 63.9496 158.988V155.598C63.9496 155.347 63.7559 155.145 63.517 155.145Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1548 158.987C41.1548 159.238 41.3485 159.44 41.5874 159.44H63.517C63.7559 159.44 63.9496 159.238 63.9496 158.987H41.1548Z",
    fill: "url(#paint17_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1548 155.598C41.1548 155.347 41.3485 155.145 41.5874 155.145H63.517C63.7559 155.145 63.9496 155.347 63.9496 155.598H41.1548Z",
    fill: "url(#paint18_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8412 155.981H52.2637V158.603H52.8412V155.981Z",
    fill: "url(#paint19_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1786 155.981H50.6011V158.603H51.1786V155.981Z",
    fill: "url(#paint20_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.516 155.981H48.9385V158.603H49.516V155.981Z",
    fill: "url(#paint21_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8534 155.981H47.2759V158.603H47.8534V155.981Z",
    fill: "url(#paint22_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1908 155.981H45.6133V158.603H46.1908V155.981Z",
    fill: "url(#paint23_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5282 155.981H43.9507V158.603H44.5282V155.981Z",
    fill: "url(#paint24_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8656 155.981H42.2881V158.603H42.8656V155.981Z",
    fill: "url(#paint25_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8168 155.981H62.2393V158.603H62.8168V155.981Z",
    fill: "url(#paint26_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1542 155.981H60.5767V158.603H61.1542V155.981Z",
    fill: "url(#paint27_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4916 155.981H58.9141V158.603H59.4916V155.981Z",
    fill: "url(#paint28_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.829 155.981H57.2515V158.603H57.829V155.981Z",
    fill: "url(#paint29_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1664 155.981H55.5889V158.603H56.1664V155.981Z",
    fill: "url(#paint30_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5038 155.981H53.9263V158.603H54.5038V155.981Z",
    fill: "url(#paint31_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4115 150.849H40.4819C40.243 150.849 40.0493 151.052 40.0493 151.302V154.692C40.0493 154.943 40.243 155.145 40.4819 155.145H62.4115C62.6504 155.145 62.8441 154.943 62.8441 154.692V151.302C62.8441 151.052 62.6504 150.849 62.4115 150.849Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0493 154.693C40.0493 154.944 40.243 155.147 40.4819 155.147H62.4115C62.6504 155.147 62.8441 154.944 62.8441 154.693H40.0493Z",
    fill: "url(#paint32_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0493 151.303C40.0493 151.053 40.243 150.85 40.4819 150.85H62.4115C62.6504 150.85 62.8441 151.053 62.8441 151.303H40.0493Z",
    fill: "url(#paint33_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7352 151.686H51.1577V154.307H51.7352V151.686Z",
    fill: "url(#paint34_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0726 151.686H49.4951V154.307H50.0726V151.686Z",
    fill: "url(#paint35_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4105 151.686H47.833V154.307H48.4105V151.686Z",
    fill: "url(#paint36_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7479 151.686H46.1704V154.307H46.7479V151.686Z",
    fill: "url(#paint37_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0848 151.686H44.5073V154.307H45.0848V151.686Z",
    fill: "url(#paint38_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4222 151.686H42.8447V154.307H43.4222V151.686Z",
    fill: "url(#paint39_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7601 151.686H41.1826V154.307H41.7601V151.686Z",
    fill: "url(#paint40_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7113 151.686H61.1338V154.307H61.7113V151.686Z",
    fill: "url(#paint41_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0487 151.686H59.4712V154.307H60.0487V151.686Z",
    fill: "url(#paint42_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3856 151.686H57.8081V154.307H58.3856V151.686Z",
    fill: "url(#paint43_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7235 151.686H56.146V154.307H56.7235V151.686Z",
    fill: "url(#paint44_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0609 151.686H54.4834V154.307H55.0609V151.686Z",
    fill: "url(#paint45_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3983 151.686H52.8208V154.307H53.3983V151.686Z",
    fill: "url(#paint46_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7777 146.548H41.8481C41.6092 146.548 41.4155 146.751 41.4155 147.001V150.392C41.4155 150.642 41.6092 150.845 41.8481 150.845H63.7777C64.0167 150.845 64.2103 150.642 64.2103 150.392V147.001C64.2103 146.751 64.0167 146.548 63.7777 146.548Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4155 150.391C41.4155 150.641 41.6092 150.844 41.8481 150.844H63.7777C64.0167 150.844 64.2103 150.641 64.2103 150.391H41.4155Z",
    fill: "url(#paint47_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4155 147.001C41.4155 146.751 41.6092 146.548 41.8481 146.548H63.7777C64.0167 146.548 64.2103 146.751 64.2103 147.001H41.4155Z",
    fill: "url(#paint48_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1014 147.387H52.5239V150.009H53.1014V147.387Z",
    fill: "url(#paint49_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4393 147.387H50.8618V150.009H51.4393V147.387Z",
    fill: "url(#paint50_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7767 147.387H49.1992V150.009H49.7767V147.387Z",
    fill: "url(#paint51_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1141 147.387H47.5366V150.009H48.1141V147.387Z",
    fill: "url(#paint52_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.451 147.387H45.8735V150.009H46.451V147.387Z",
    fill: "url(#paint53_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7889 147.387H44.2114V150.009H44.7889V147.387Z",
    fill: "url(#paint54_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1263 147.387H42.5488V150.009H43.1263V147.387Z",
    fill: "url(#paint55_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0775 147.387H62.5V150.009H63.0775V147.387Z",
    fill: "url(#paint56_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4149 147.387H60.8374V150.009H61.4149V147.387Z",
    fill: "url(#paint57_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7518 147.387H59.1743V150.009H59.7518V147.387Z",
    fill: "url(#paint58_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0897 147.387H57.5122V150.009H58.0897V147.387Z",
    fill: "url(#paint59_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4271 147.387H55.8496V150.009H56.4271V147.387Z",
    fill: "url(#paint60_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7645 147.387H54.187V150.009H54.7645V147.387Z",
    fill: "url(#paint61_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9086 142.25H40.979C40.7401 142.25 40.5464 142.453 40.5464 142.703V146.094C40.5464 146.344 40.7401 146.547 40.979 146.547H62.9086C63.1475 146.547 63.3412 146.344 63.3412 146.094V142.703C63.3412 142.453 63.1475 142.25 62.9086 142.25Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5464 146.093C40.5464 146.343 40.7401 146.546 40.979 146.546H62.9086C63.1475 146.546 63.3412 146.343 63.3412 146.093H40.5464Z",
    fill: "url(#paint62_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5464 142.702C40.5464 142.452 40.7401 142.249 40.979 142.249H62.9086C63.1475 142.249 63.3412 142.452 63.3412 142.702H40.5464Z",
    fill: "url(#paint63_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2328 143.087H51.6553V145.709H52.2328V143.087Z",
    fill: "url(#paint64_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5697 143.087H49.9922V145.709H50.5697V143.087Z",
    fill: "url(#paint65_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9076 143.087H48.3301V145.709H48.9076V143.087Z",
    fill: "url(#paint66_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.245 143.087H46.6675V145.709H47.245V143.087Z",
    fill: "url(#paint67_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5824 143.087H45.0049V145.709H45.5824V143.087Z",
    fill: "url(#paint68_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9198 143.087H43.3423V145.709H43.9198V143.087Z",
    fill: "url(#paint69_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2572 143.087H41.6797V145.709H42.2572V143.087Z",
    fill: "url(#paint70_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2084 143.087H61.6309V145.709H62.2084V143.087Z",
    fill: "url(#paint71_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5458 143.087H59.9683V145.709H60.5458V143.087Z",
    fill: "url(#paint72_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8832 143.087H58.3057V145.709H58.8832V143.087Z",
    fill: "url(#paint73_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2206 143.087H56.6431V145.709H57.2206V143.087Z",
    fill: "url(#paint74_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.558 143.087H54.9805V145.709H55.558V143.087Z",
    fill: "url(#paint75_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8949 143.087H53.3174V145.709H53.8949V143.087Z",
    fill: "url(#paint76_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4608 137.959H42.5313C42.2923 137.959 42.0986 138.162 42.0986 138.412V141.803C42.0986 142.053 42.2923 142.256 42.5313 142.256H64.4608C64.6998 142.256 64.8934 142.053 64.8934 141.803V138.412C64.8934 138.162 64.6998 137.959 64.4608 137.959Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0986 141.803C42.0986 142.053 42.2923 142.256 42.5313 142.256H64.4608C64.6998 142.256 64.8934 142.053 64.8934 141.803H42.0986Z",
    fill: "url(#paint77_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0986 138.413C42.0986 138.163 42.2923 137.96 42.5313 137.96H64.4608C64.6998 137.96 64.8934 138.163 64.8934 138.413H42.0986Z",
    fill: "url(#paint78_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.785 138.795H53.2075V141.417H53.785V138.795Z",
    fill: "url(#paint79_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1224 138.795H51.5449V141.417H52.1224V138.795Z",
    fill: "url(#paint80_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4598 138.795H49.8823V141.417H50.4598V138.795Z",
    fill: "url(#paint81_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7972 138.795H48.2197V141.417H48.7972V138.795Z",
    fill: "url(#paint82_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1346 138.795H46.5571V141.417H47.1346V138.795Z",
    fill: "url(#paint83_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.472 138.795H44.8945V141.417H45.472V138.795Z",
    fill: "url(#paint84_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8094 138.795H43.2319V141.417H43.8094V138.795Z",
    fill: "url(#paint85_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7606 138.795H63.1831V141.417H63.7606V138.795Z",
    fill: "url(#paint86_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.098 138.795H61.5205V141.417H62.098V138.795Z",
    fill: "url(#paint87_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4354 138.795H59.8579V141.417H60.4354V138.795Z",
    fill: "url(#paint88_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7728 138.795H58.1953V141.417H58.7728V138.795Z",
    fill: "url(#paint89_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1102 138.795H56.5327V141.417H57.1102V138.795Z",
    fill: "url(#paint90_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4476 138.795H54.8701V141.417H55.4476V138.795Z",
    fill: "url(#paint91_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7777 133.658H41.8481C41.6092 133.658 41.4155 133.861 41.4155 134.111V137.502C41.4155 137.752 41.6092 137.955 41.8481 137.955H63.7777C64.0167 137.955 64.2103 137.752 64.2103 137.502V134.111C64.2103 133.861 64.0167 133.658 63.7777 133.658Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4155 137.502C41.4155 137.752 41.6092 137.955 41.8481 137.955H63.7777C64.0167 137.955 64.2103 137.752 64.2103 137.502H41.4155Z",
    fill: "url(#paint92_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4155 134.112C41.4155 133.862 41.6092 133.659 41.8481 133.659H63.7777C64.0167 133.659 64.2103 133.862 64.2103 134.112H41.4155Z",
    fill: "url(#paint93_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1014 134.497H52.5239V137.119H53.1014V134.497Z",
    fill: "url(#paint94_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4393 134.497H50.8618V137.119H51.4393V134.497Z",
    fill: "url(#paint95_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7767 134.497H49.1992V137.119H49.7767V134.497Z",
    fill: "url(#paint96_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1141 134.497H47.5366V137.119H48.1141V134.497Z",
    fill: "url(#paint97_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.451 134.497H45.8735V137.119H46.451V134.497Z",
    fill: "url(#paint98_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7889 134.497H44.2114V137.119H44.7889V134.497Z",
    fill: "url(#paint99_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1263 134.497H42.5488V137.119H43.1263V134.497Z",
    fill: "url(#paint100_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0775 134.497H62.5V137.119H63.0775V134.497Z",
    fill: "url(#paint101_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4149 134.497H60.8374V137.119H61.4149V134.497Z",
    fill: "url(#paint102_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7518 134.497H59.1743V137.119H59.7518V134.497Z",
    fill: "url(#paint103_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0897 134.497H57.5122V137.119H58.0897V134.497Z",
    fill: "url(#paint104_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4271 134.497H55.8496V137.119H56.4271V134.497Z",
    fill: "url(#paint105_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7645 134.497H54.187V137.119H54.7645V134.497Z",
    fill: "url(#paint106_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6468 129.361H42.7173C42.4783 129.361 42.2847 129.564 42.2847 129.814V133.205C42.2847 133.455 42.4783 133.658 42.7173 133.658H64.6468C64.8858 133.658 65.0795 133.455 65.0795 133.205V129.814C65.0795 129.564 64.8858 129.361 64.6468 129.361Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2847 133.204C42.2847 133.454 42.4783 133.657 42.7173 133.657H64.6468C64.8858 133.657 65.0795 133.454 65.0795 133.204H42.2847Z",
    fill: "url(#paint107_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2847 129.814C42.2847 129.563 42.4783 129.36 42.7173 129.36H64.6468C64.8858 129.36 65.0795 129.563 65.0795 129.814H42.2847Z",
    fill: "url(#paint108_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9711 130.2H53.3936V132.822H53.9711V130.2Z",
    fill: "url(#paint109_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3085 130.2H51.731V132.822H52.3085V130.2Z",
    fill: "url(#paint110_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6459 130.2H50.0684V132.822H50.6459V130.2Z",
    fill: "url(#paint111_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9833 130.2H48.4058V132.822H48.9833V130.2Z",
    fill: "url(#paint112_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3207 130.2H46.7432V132.822H47.3207V130.2Z",
    fill: "url(#paint113_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6581 130.2H45.0806V132.822H45.6581V130.2Z",
    fill: "url(#paint114_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9955 130.2H43.418V132.822H43.9955V130.2Z",
    fill: "url(#paint115_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9466 130.2H63.3691V132.822H63.9466V130.2Z",
    fill: "url(#paint116_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2841 130.2H61.7065V132.822H62.2841V130.2Z",
    fill: "url(#paint117_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6214 130.2H60.0439V132.822H60.6214V130.2Z",
    fill: "url(#paint118_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9588 130.2H58.3813V132.822H58.9588V130.2Z",
    fill: "url(#paint119_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2963 130.2H56.7188V132.822H57.2963V130.2Z",
    fill: "url(#paint120_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6337 130.2H55.0562V132.822H55.6337V130.2Z",
    fill: "url(#paint121_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0946 125.064H41.165C40.9261 125.064 40.7324 125.267 40.7324 125.518V128.908C40.7324 129.158 40.9261 129.361 41.165 129.361H63.0946C63.3335 129.361 63.5272 129.158 63.5272 128.908V125.518C63.5272 125.267 63.3335 125.064 63.0946 125.064Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7324 128.907C40.7324 129.158 40.9261 129.36 41.165 129.36H63.0946C63.3335 129.36 63.5272 129.158 63.5272 128.907H40.7324Z",
    fill: "url(#paint122_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7324 125.518C40.7324 125.267 40.9261 125.064 41.165 125.064H63.0946C63.3335 125.064 63.5272 125.267 63.5272 125.518H40.7324Z",
    fill: "url(#paint123_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4188 125.901H51.8413V128.523H52.4188V125.901Z",
    fill: "url(#paint124_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7562 125.901H50.1787V128.523H50.7562V125.901Z",
    fill: "url(#paint125_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0936 125.901H48.5161V128.523H49.0936V125.901Z",
    fill: "url(#paint126_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.431 125.901H46.8535V128.523H47.431V125.901Z",
    fill: "url(#paint127_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7684 125.901H45.1909V128.523H45.7684V125.901Z",
    fill: "url(#paint128_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1058 125.901H43.5283V128.523H44.1058V125.901Z",
    fill: "url(#paint129_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4432 125.901H41.8657V128.523H42.4432V125.901Z",
    fill: "url(#paint130_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3944 125.901H61.8169V128.523H62.3944V125.901Z",
    fill: "url(#paint131_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7318 125.901H60.1543V128.523H60.7318V125.901Z",
    fill: "url(#paint132_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0692 125.901H58.4917V128.523H59.0692V125.901Z",
    fill: "url(#paint133_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4066 125.901H56.8291V128.523H57.4066V125.901Z",
    fill: "url(#paint134_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.744 125.901H55.1665V128.523H55.744V125.901Z",
    fill: "url(#paint135_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0814 125.901H53.5039V128.523H54.0814V125.901Z",
    fill: "url(#paint136_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6468 120.768H42.7173C42.4783 120.768 42.2847 120.97 42.2847 121.221V124.611C42.2847 124.862 42.4783 125.064 42.7173 125.064H64.6468C64.8858 125.064 65.0795 124.861 65.0795 124.611V121.221C65.0795 120.97 64.8858 120.768 64.6468 120.768Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2847 124.613C42.2847 124.864 42.4783 125.066 42.7173 125.066H64.6468C64.8858 125.066 65.0795 124.864 65.0795 124.613H42.2847Z",
    fill: "url(#paint137_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2847 121.219C42.2847 120.969 42.4783 120.766 42.7173 120.766H64.6468C64.8858 120.766 65.0795 120.969 65.0795 121.219H42.2847Z",
    fill: "url(#paint138_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9711 121.604H53.3936V124.225H53.9711V121.604Z",
    fill: "url(#paint139_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3085 121.604H51.731V124.225H52.3085V121.604Z",
    fill: "url(#paint140_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6459 121.604H50.0684V124.225H50.6459V121.604Z",
    fill: "url(#paint141_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9833 121.604H48.4058V124.225H48.9833V121.604Z",
    fill: "url(#paint142_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3207 121.604H46.7432V124.225H47.3207V121.604Z",
    fill: "url(#paint143_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6581 121.604H45.0806V124.225H45.6581V121.604Z",
    fill: "url(#paint144_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9955 121.604H43.418V124.225H43.9955V121.604Z",
    fill: "url(#paint145_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9466 121.604H63.3691V124.225H63.9466V121.604Z",
    fill: "url(#paint146_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2841 121.604H61.7065V124.225H62.2841V121.604Z",
    fill: "url(#paint147_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6214 121.604H60.0439V124.225H60.6214V121.604Z",
    fill: "url(#paint148_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9588 121.604H58.3813V124.225H58.9588V121.604Z",
    fill: "url(#paint149_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2963 121.604H56.7188V124.225H57.2963V121.604Z",
    fill: "url(#paint150_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6337 121.604H55.0562V124.225H55.6337V121.604Z",
    fill: "url(#paint151_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.483 86.8857H84.0962C79.5749 86.8857 75.8965 90.5795 75.8965 95.1197V102.207H81.5013V95.1197C81.5013 93.6829 82.6654 92.514 84.0962 92.514H109.483C110.914 92.514 112.078 93.6829 112.078 95.1197V102.207H117.682V95.1197C117.682 90.5795 114.004 86.8857 109.483 86.8857Z",
    fill: "url(#paint152_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 120C52 120 53.0602 149.986 54.0389 159.82C54.33 162.745 56.4123 165.143 59.3399 165.143H134.259C137.186 165.143 139.254 162.744 139.56 159.82C140.579 150.072 141.598 120 141.598 120H52Z",
    fill: "url(#paint153_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.872 101.888H57.707C54.0985 101.888 51.1733 104.825 51.1733 108.449V120.073C51.1733 121.072 52.0249 121.584 52.9746 121.882C64.3939 125.46 96.885 134.255 96.885 134.255C96.885 134.255 130.058 124.773 140.604 121.882C141.564 121.619 142.406 121.072 142.406 120.073V108.449C142.406 104.825 139.48 101.888 135.872 101.888Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.47 136.583V129.62C105.47 128.254 104.367 127.146 103.007 127.146H90.572C89.2117 127.146 88.1089 128.254 88.1089 129.62V136.583C88.1089 137.949 89.2117 139.057 90.572 139.057H103.007C104.367 139.057 105.47 137.949 105.47 136.583Z",
    fill: "url(#paint154_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.128 134.367V131.837C102.128 130.846 101.328 130.042 100.341 130.042H93.238C92.2509 130.042 91.4507 130.846 91.4507 131.837V134.367C91.4507 135.358 92.2509 136.162 93.238 136.162H100.341C101.328 136.162 102.128 135.358 102.128 134.367Z",
    fill: "#E9F3F5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.646 138.153L146.083 136.716L157.722 148.355L156.285 149.792L144.646 138.153ZM146.083 137.218L145.148 138.153L156.285 149.29L157.22 148.355L146.083 137.218Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.879 142.551C140.706 142.551 141.377 141.88 141.377 141.053C141.377 140.225 140.706 139.555 139.879 139.555C139.051 139.555 138.38 140.225 138.38 141.053C138.38 141.88 139.051 142.551 139.879 142.551Z",
    fill: "#FFAD0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.619 139.491L147.49 135.504L145.427 133.441L141.44 136.313L144.619 139.491Z",
    fill: "url(#paint155_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.894 143.669C145.339 142.224 145.339 139.882 143.894 138.437L142.491 137.034C141.046 135.589 138.704 135.589 137.259 137.034L143.894 143.669Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.26 137.033L137.908 137.681C139.031 136.558 140.905 136.205 142.269 136.828C142.256 136.823 142.282 136.833 142.269 136.828L146.073 134.088L145.425 133.439L141.452 136.302C140.08 135.657 138.394 135.899 137.26 137.033Z",
    fill: "#69ABB9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.896 143.668L137.261 137.033C136.875 137.419 136.875 138.046 137.261 138.432L142.498 143.668C142.884 144.054 143.51 144.054 143.896 143.668Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.105 135.121L147.621 134.354L146.576 133.309L145.809 133.824L147.105 135.121Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.089 163.691L155.749 147.576L157.347 148.832L144.687 164.946L143.089 163.691ZM155.809 148.074L143.587 163.631L144.627 164.448L156.849 148.891L155.809 148.074Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.023 150.386C157.143 150.386 158.052 149.478 158.052 148.357C158.052 147.237 157.143 146.328 156.023 146.328C154.902 146.328 153.994 147.237 153.994 148.357C153.994 149.478 154.902 150.386 156.023 150.386Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.024 149.43C156.617 149.43 157.099 148.949 157.099 148.356C157.099 147.762 156.617 147.281 156.024 147.281C155.431 147.281 154.95 147.762 154.95 148.356C154.95 148.949 155.431 149.43 156.024 149.43Z",
    fill: "url(#paint156_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.519 165.074H151.098V163.28H140.519V165.074Z",
    fill: "url(#paint157_linear_2761_30850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.033 163.278H148.586L147.983 161.484H143.637L143.033 163.278Z",
    fill: "#69ABB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2761_30850",
    x1: 66.1088,
    y1: 7,
    x2: 36.1767,
    y2: 32.6082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2761_30850",
    x1: 156.823,
    y1: 72.4619,
    x2: 148.493,
    y2: 86.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2761_30850",
    x1: 41.4155,
    y1: 163.51,
    x2: 64.2103,
    y2: 163.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2761_30850",
    x1: 41.4155,
    y1: 159.671,
    x2: 64.2103,
    y2: 159.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2761_30850",
    x1: 52.5239,
    y1: 161.592,
    x2: 53.1014,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2761_30850",
    x1: 50.8618,
    y1: 161.592,
    x2: 51.4393,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2761_30850",
    x1: 49.1992,
    y1: 161.592,
    x2: 49.7767,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2761_30850",
    x1: 47.5366,
    y1: 161.592,
    x2: 48.1141,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2761_30850",
    x1: 45.8736,
    y1: 161.592,
    x2: 46.4511,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2761_30850",
    x1: 44.2114,
    y1: 161.592,
    x2: 44.7889,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2761_30850",
    x1: 42.5488,
    y1: 161.592,
    x2: 43.1263,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2761_30850",
    x1: 62.5,
    y1: 161.592,
    x2: 63.0775,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2761_30850",
    x1: 60.8374,
    y1: 161.592,
    x2: 61.4149,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2761_30850",
    x1: 59.1743,
    y1: 161.592,
    x2: 59.7518,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2761_30850",
    x1: 57.5122,
    y1: 161.592,
    x2: 58.0897,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2761_30850",
    x1: 55.8496,
    y1: 161.592,
    x2: 56.4271,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2761_30850",
    x1: 54.187,
    y1: 161.592,
    x2: 54.7645,
    y2: 161.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2761_30850",
    x1: 41.1548,
    y1: 159.214,
    x2: 63.9496,
    y2: 159.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2761_30850",
    x1: 41.1548,
    y1: 155.371,
    x2: 63.9496,
    y2: 155.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2761_30850",
    x1: 52.2637,
    y1: 157.292,
    x2: 52.8412,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2761_30850",
    x1: 50.6011,
    y1: 157.292,
    x2: 51.1786,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2761_30850",
    x1: 48.9385,
    y1: 157.292,
    x2: 49.516,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2761_30850",
    x1: 47.2759,
    y1: 157.292,
    x2: 47.8534,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2761_30850",
    x1: 45.6133,
    y1: 157.292,
    x2: 46.1908,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2761_30850",
    x1: 43.9507,
    y1: 157.292,
    x2: 44.5282,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2761_30850",
    x1: 42.2881,
    y1: 157.292,
    x2: 42.8656,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2761_30850",
    x1: 62.2393,
    y1: 157.292,
    x2: 62.8168,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2761_30850",
    x1: 60.5767,
    y1: 157.292,
    x2: 61.1541,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2761_30850",
    x1: 58.9141,
    y1: 157.292,
    x2: 59.4916,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2761_30850",
    x1: 57.2515,
    y1: 157.292,
    x2: 57.829,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2761_30850",
    x1: 55.5889,
    y1: 157.292,
    x2: 56.1664,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2761_30850",
    x1: 53.9263,
    y1: 157.292,
    x2: 54.5038,
    y2: 157.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2761_30850",
    x1: 40.0493,
    y1: 154.92,
    x2: 62.8441,
    y2: 154.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2761_30850",
    x1: 40.0493,
    y1: 151.076,
    x2: 62.8441,
    y2: 151.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2761_30850",
    x1: 51.1577,
    y1: 152.996,
    x2: 51.7352,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2761_30850",
    x1: 49.4951,
    y1: 152.996,
    x2: 50.0726,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2761_30850",
    x1: 47.833,
    y1: 152.996,
    x2: 48.4105,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2761_30850",
    x1: 46.1704,
    y1: 152.996,
    x2: 46.7479,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2761_30850",
    x1: 44.5073,
    y1: 152.996,
    x2: 45.0848,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2761_30850",
    x1: 42.8447,
    y1: 152.996,
    x2: 43.4222,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2761_30850",
    x1: 41.1826,
    y1: 152.996,
    x2: 41.7601,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2761_30850",
    x1: 61.1338,
    y1: 152.996,
    x2: 61.7113,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2761_30850",
    x1: 59.4712,
    y1: 152.996,
    x2: 60.0487,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2761_30850",
    x1: 57.8081,
    y1: 152.996,
    x2: 58.3856,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2761_30850",
    x1: 56.146,
    y1: 152.996,
    x2: 56.7235,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2761_30850",
    x1: 54.4834,
    y1: 152.996,
    x2: 55.0609,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2761_30850",
    x1: 52.8208,
    y1: 152.996,
    x2: 53.3983,
    y2: 152.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2761_30850",
    x1: 41.4155,
    y1: 150.617,
    x2: 64.2103,
    y2: 150.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2761_30850",
    x1: 41.4155,
    y1: 146.774,
    x2: 64.2103,
    y2: 146.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2761_30850",
    x1: 52.5239,
    y1: 148.698,
    x2: 53.1014,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2761_30850",
    x1: 50.8618,
    y1: 148.698,
    x2: 51.4393,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2761_30850",
    x1: 49.1992,
    y1: 148.698,
    x2: 49.7767,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2761_30850",
    x1: 47.5366,
    y1: 148.698,
    x2: 48.1141,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2761_30850",
    x1: 45.8736,
    y1: 148.698,
    x2: 46.4511,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2761_30850",
    x1: 44.2114,
    y1: 148.698,
    x2: 44.7889,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2761_30850",
    x1: 42.5488,
    y1: 148.698,
    x2: 43.1263,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2761_30850",
    x1: 62.5,
    y1: 148.698,
    x2: 63.0775,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2761_30850",
    x1: 60.8374,
    y1: 148.698,
    x2: 61.4149,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2761_30850",
    x1: 59.1743,
    y1: 148.698,
    x2: 59.7518,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2761_30850",
    x1: 57.5122,
    y1: 148.698,
    x2: 58.0897,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2761_30850",
    x1: 55.8496,
    y1: 148.698,
    x2: 56.4271,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2761_30850",
    x1: 54.187,
    y1: 148.698,
    x2: 54.7645,
    y2: 148.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2761_30850",
    x1: 40.5464,
    y1: 146.319,
    x2: 63.3412,
    y2: 146.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2761_30850",
    x1: 40.5464,
    y1: 142.476,
    x2: 63.3412,
    y2: 142.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2761_30850",
    x1: 51.6553,
    y1: 144.398,
    x2: 52.2328,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2761_30850",
    x1: 49.9922,
    y1: 144.398,
    x2: 50.5697,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2761_30850",
    x1: 48.3301,
    y1: 144.398,
    x2: 48.9076,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2761_30850",
    x1: 46.6675,
    y1: 144.398,
    x2: 47.245,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2761_30850",
    x1: 45.0049,
    y1: 144.398,
    x2: 45.5824,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2761_30850",
    x1: 43.3423,
    y1: 144.398,
    x2: 43.9198,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2761_30850",
    x1: 41.6797,
    y1: 144.398,
    x2: 42.2572,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2761_30850",
    x1: 61.6308,
    y1: 144.398,
    x2: 62.2083,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2761_30850",
    x1: 59.9683,
    y1: 144.398,
    x2: 60.5458,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2761_30850",
    x1: 58.3057,
    y1: 144.398,
    x2: 58.8831,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2761_30850",
    x1: 56.6431,
    y1: 144.398,
    x2: 57.2206,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2761_30850",
    x1: 54.9805,
    y1: 144.398,
    x2: 55.558,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2761_30850",
    x1: 53.3174,
    y1: 144.398,
    x2: 53.8949,
    y2: 144.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2761_30850",
    x1: 42.0986,
    y1: 142.029,
    x2: 64.8934,
    y2: 142.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2761_30850",
    x1: 42.0986,
    y1: 138.187,
    x2: 64.8934,
    y2: 138.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2761_30850",
    x1: 53.2075,
    y1: 140.106,
    x2: 53.785,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2761_30850",
    x1: 51.5449,
    y1: 140.106,
    x2: 52.1224,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2761_30850",
    x1: 49.8823,
    y1: 140.106,
    x2: 50.4598,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2761_30850",
    x1: 48.2197,
    y1: 140.106,
    x2: 48.7972,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2761_30850",
    x1: 46.5571,
    y1: 140.106,
    x2: 47.1346,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2761_30850",
    x1: 44.8945,
    y1: 140.106,
    x2: 45.472,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2761_30850",
    x1: 43.2319,
    y1: 140.106,
    x2: 43.8094,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2761_30850",
    x1: 63.1831,
    y1: 140.106,
    x2: 63.7606,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2761_30850",
    x1: 61.5205,
    y1: 140.106,
    x2: 62.098,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2761_30850",
    x1: 59.8579,
    y1: 140.106,
    x2: 60.4354,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2761_30850",
    x1: 58.1953,
    y1: 140.106,
    x2: 58.7728,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2761_30850",
    x1: 56.5327,
    y1: 140.106,
    x2: 57.1102,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2761_30850",
    x1: 54.8701,
    y1: 140.106,
    x2: 55.4476,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2761_30850",
    x1: 41.4155,
    y1: 137.729,
    x2: 64.2103,
    y2: 137.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2761_30850",
    x1: 41.4155,
    y1: 133.886,
    x2: 64.2103,
    y2: 133.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2761_30850",
    x1: 52.5239,
    y1: 135.808,
    x2: 53.1014,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2761_30850",
    x1: 50.8618,
    y1: 135.808,
    x2: 51.4393,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2761_30850",
    x1: 49.1992,
    y1: 135.808,
    x2: 49.7767,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2761_30850",
    x1: 47.5366,
    y1: 135.808,
    x2: 48.1141,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2761_30850",
    x1: 45.8736,
    y1: 135.808,
    x2: 46.4511,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2761_30850",
    x1: 44.2114,
    y1: 135.808,
    x2: 44.7889,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2761_30850",
    x1: 42.5488,
    y1: 135.808,
    x2: 43.1263,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2761_30850",
    x1: 62.5,
    y1: 135.808,
    x2: 63.0775,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2761_30850",
    x1: 60.8374,
    y1: 135.808,
    x2: 61.4149,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2761_30850",
    x1: 59.1743,
    y1: 135.808,
    x2: 59.7518,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2761_30850",
    x1: 57.5122,
    y1: 135.808,
    x2: 58.0897,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2761_30850",
    x1: 55.8496,
    y1: 135.808,
    x2: 56.4271,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2761_30850",
    x1: 54.187,
    y1: 135.808,
    x2: 54.7645,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2761_30850",
    x1: 42.2847,
    y1: 133.431,
    x2: 65.0795,
    y2: 133.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2761_30850",
    x1: 42.2847,
    y1: 129.587,
    x2: 65.0795,
    y2: 129.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2761_30850",
    x1: 53.3936,
    y1: 131.511,
    x2: 53.971,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2761_30850",
    x1: 51.731,
    y1: 131.511,
    x2: 52.3085,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2761_30850",
    x1: 50.0684,
    y1: 131.511,
    x2: 50.6459,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2761_30850",
    x1: 48.4058,
    y1: 131.511,
    x2: 48.9833,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2761_30850",
    x1: 46.7432,
    y1: 131.511,
    x2: 47.3207,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2761_30850",
    x1: 45.0805,
    y1: 131.511,
    x2: 45.658,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2761_30850",
    x1: 43.418,
    y1: 131.511,
    x2: 43.9955,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2761_30850",
    x1: 63.3691,
    y1: 131.511,
    x2: 63.9466,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2761_30850",
    x1: 61.7066,
    y1: 131.511,
    x2: 62.2841,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2761_30850",
    x1: 60.0439,
    y1: 131.511,
    x2: 60.6214,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2761_30850",
    x1: 58.3814,
    y1: 131.511,
    x2: 58.9589,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2761_30850",
    x1: 56.7187,
    y1: 131.511,
    x2: 57.2962,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2761_30850",
    x1: 55.0562,
    y1: 131.511,
    x2: 55.6337,
    y2: 131.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2761_30850",
    x1: 40.7324,
    y1: 129.134,
    x2: 63.5272,
    y2: 129.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2761_30850",
    x1: 40.7324,
    y1: 125.291,
    x2: 63.5272,
    y2: 125.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2761_30850",
    x1: 51.8413,
    y1: 127.212,
    x2: 52.4188,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2761_30850",
    x1: 50.1787,
    y1: 127.212,
    x2: 50.7562,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2761_30850",
    x1: 48.5161,
    y1: 127.212,
    x2: 49.0936,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2761_30850",
    x1: 46.8535,
    y1: 127.212,
    x2: 47.431,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2761_30850",
    x1: 45.1909,
    y1: 127.212,
    x2: 45.7684,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2761_30850",
    x1: 43.5283,
    y1: 127.212,
    x2: 44.1058,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2761_30850",
    x1: 41.8657,
    y1: 127.212,
    x2: 42.4432,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2761_30850",
    x1: 61.8169,
    y1: 127.212,
    x2: 62.3944,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2761_30850",
    x1: 60.1543,
    y1: 127.212,
    x2: 60.7318,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2761_30850",
    x1: 58.4917,
    y1: 127.212,
    x2: 59.0692,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2761_30850",
    x1: 56.8291,
    y1: 127.212,
    x2: 57.4066,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2761_30850",
    x1: 55.1665,
    y1: 127.212,
    x2: 55.744,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2761_30850",
    x1: 53.5039,
    y1: 127.212,
    x2: 54.0814,
    y2: 127.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2761_30850",
    x1: 42.2847,
    y1: 124.84,
    x2: 65.0795,
    y2: 124.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2761_30850",
    x1: 42.2847,
    y1: 120.992,
    x2: 65.0795,
    y2: 120.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2761_30850",
    x1: 53.3936,
    y1: 122.914,
    x2: 53.971,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2761_30850",
    x1: 51.731,
    y1: 122.914,
    x2: 52.3085,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2761_30850",
    x1: 50.0684,
    y1: 122.914,
    x2: 50.6459,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2761_30850",
    x1: 48.4058,
    y1: 122.914,
    x2: 48.9833,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2761_30850",
    x1: 46.7432,
    y1: 122.914,
    x2: 47.3207,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2761_30850",
    x1: 45.0805,
    y1: 122.914,
    x2: 45.658,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2761_30850",
    x1: 43.418,
    y1: 122.914,
    x2: 43.9955,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2761_30850",
    x1: 63.3691,
    y1: 122.914,
    x2: 63.9466,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2761_30850",
    x1: 61.7066,
    y1: 122.914,
    x2: 62.2841,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2761_30850",
    x1: 60.0439,
    y1: 122.914,
    x2: 60.6214,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2761_30850",
    x1: 58.3814,
    y1: 122.914,
    x2: 58.9589,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2761_30850",
    x1: 56.7187,
    y1: 122.914,
    x2: 57.2962,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2761_30850",
    x1: 55.0562,
    y1: 122.914,
    x2: 55.6337,
    y2: 122.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2761_30850",
    x1: 128.156,
    y1: 86.8857,
    x2: 102.936,
    y2: 125.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2761_30850",
    x1: 164.056,
    y1: 120,
    x2: 83.3392,
    y2: 210.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2761_30850",
    x1: 109.821,
    y1: 127.146,
    x2: 88.814,
    y2: 144.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2761_30850",
    x1: 149.006,
    y1: 133.441,
    x2: 139.708,
    y2: 138.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2761_30850",
    x1: 157.637,
    y1: 147.281,
    x2: 154.334,
    y2: 149.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2761_30850",
    x1: 137.868,
    y1: 165.074,
    x2: 139.652,
    y2: 159.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2761_30850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 167,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2761_30850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 84,
    fill: "white",
    transform: "translate(40.0493 81)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentOpportunity);
export default __webpack_public_path__ + "static/media/Employment Opportunity.5fd0bb21aa2aa4a49a988728582f8daa.svg";
export { ForwardRef as ReactComponent };